import { useEffect, useRef } from 'react';
import { useAuthStore } from '../../stores/useAuthStore';
import { updateProfiles } from '../../services/authService';

export function useProfilesSync() {
    
    const perfisSelecionados = useAuthStore(state => state.perfisSelecionados);
    const user = useAuthStore(state => state.user);

    const firstRender = useRef(true);

    useEffect(() => {

        if (!user) {

            firstRender.current = true;

            return;
        }

        if (firstRender.current) {
            firstRender.current = false;
            return;
        }

        const timeout = setTimeout(() => {
            updateProfiles();
        }, 1000);

        return () => clearTimeout(timeout);

    }, [perfisSelecionados, user]);

}